import { createFileRoute } from '@tanstack/react-router'
import { useSearch } from "@tanstack/react-router";
import AdminLogin from "../../components/admin-page/AdminLogin.js";

export const Route = createFileRoute('/admin/current-admin-login')({
  component: RouteComponent,
})

function RouteComponent() {
  const search = useSearch({ from: "/admin/current-admin-login" });
  const data = search.data ? JSON.parse(decodeURIComponent(search.data)) : undefined;
  return <AdminLogin token={data.token} />
}
